<template>
  <div>
    <h1 class="heading-3 text--primary py-0">
      {{ title }}
    </h1>
    <span class="subtitle-1 text--secondary pt-2">
      {{ subtitle }}
    </span>
  </div>
</template>

<script lang="ts">
export default {
  name: 'ContactUsHeader',
};
</script>

<script setup lang="ts">
defineProps({
  title: {
    type: String,
    default: '',
  },
  subtitle: {
    type: String,
    default: '',
  },
});
</script>

<style scoped>

</style>
